import Button, { type ButtonProps } from './Button'

export { Button, type ButtonProps }

export default Button
